function Contact() {
    return (
        <>
            <div id="contact" className="contact bg-neutral-50">
            <div className="container max-w-screen-sm mx-auto py-8 px-4 flex flex-col justify-center items-center">
                <h2 className="font-bold text-red-500 uppercase">contact</h2>
                <h1 className="font-bold text-2xl text-center">Write me when you need</h1>
                <hr className="border-b-2 w-60 my-3 text-center" />

                <form action="/contact" method="POST" className="w-full">
                    <label className="mt-4 block text-gray-700 text-sm font-bold mb-2" for="username">Name or Nickname</label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        type="text" name="username" required autocomplete="off" minlength="3"
                        placeholder="Example Kevin" />
                    <label className="mt-4 block text-gray-700 text-sm font-bold mb-2" for="email">E-Mail</label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        type="email" name="email" required autocomplete="off" minlength="5"
                        placeholder="example.kevin@mail.com" />
                    <label className="mt-4 block text-gray-700 text-sm font-bold mb-2" for="subject">Subject</label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        type="text" name="subject" required autocomplete="off" minlength="3"
                        placeholder="Website / DNS setup / VPS setup / etc." />
                    <label className="mt-4 block text-gray-700 text-sm font-bold mb-2" for="description">Description</label>
                    <textarea
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                        type="text" name="description" required autocomplete="off" rows="5" minlength="10"
                        placeholder="Describe your request"></textarea>
                    <div className="w-full flex justify-center"> <input type="submit" value="send request" className="py-3 px-5 mt-4 bg-red-500 hover:bg-red-600 font-bold uppercase rounded-lg text-white"></input> </div>
                </form>

            </div>
        </div>
        </>
    );
}

export default Contact;